import { Drawer } from '@mui/material'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { acDrawerToggle } from '../../../store/actions'
import { DRAWER_WIDTH } from '../../../store/constants'

import DrawerContent from './DrawerContent'

/**
 * Renders a temporary drawer component.
 *
 * @author Maria Eduarda Franke
 * @param {Object} props - The component props.
 * @param {string} props.selectedKey - The selected key.
 * @returns {JSX.Element} The temporary drawer component.
 */
const TemporaryDrawer = ({ selectedKey }) => {

    const dispatch = useDispatch()

    const isOpen = useSelector(state => state.drawer.isOpen)

    return (
        <Drawer
            variant='temporary'
            anchor='left'
            open={isOpen}
            onClose={() => dispatch(acDrawerToggle())}
            ModalProps={{ keepMounted: true }}
            sx={{
                display: { sm: 'block', md: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: `${DRAWER_WIDTH}px` },
            }}
        >
            <DrawerContent selectedKey={selectedKey} temporary={true} />
        </Drawer>
    )
}


TemporaryDrawer.propTypes = {
    selectedKey: PropTypes.string.isRequired
}

export default TemporaryDrawer